<template>
    <footer class="footer text-center" :class="{'gray-theme' : grayTheme}">
        <div class="container">
            <div class="navigation-links-wrapper">
                <NavigationLinks :footer-links="footerLinks" :gray-theme="grayTheme" />
            </div>
        </div>
    </footer>
</template>

<script>
import NavigationLinks from './NavigationLinks';

export default {
    components: { NavigationLinks },
    props: {
        footerLinks: {
            type: Object,
            required: true,
            default: () => {},
        },
        grayTheme: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
};
</script>

<style lang="scss">
@import '../../scss/variables';

.footer {
  background-color: $navy-blue;
  padding: 1.5rem 0;

  .navigation-links-wrapper {
    > div {
      > a {
        display: none;
      }

      @media screen and (min-width: 992px) {
        display: flex;
        justify-content: space-between;
        > a {
          display: inline-block;
        }
        ul {
          display: flex;
          li:first-child {
            display: none;
          }
          li a {
            margin-bottom: .25rem;
            padding-left: 1rem;
          }
        }
      }
    }
  }
  &.gray-theme {
    background-color: #F2F2F2;
  }
}
</style>
